import React from 'react'
import { Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_MODIFICAR_CPA } from '../../../../config/forms'
import FieldCpa from '../../../Forms/SharedComponents/containers/FieldCpa'

function ModificarCpa (props) {
  return (
    <>
      <h2>Modificar cpa</h2>
      <Row className='justify-content-md-center' style={{ justifyContent: 'center' }}>
        <FieldCpa
          label='Número de CPA'

        />
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_MODIFICAR_CPA
//   enableReinitialize: true,
//   keepDirtyOnReinitialize: true,
//   destroyOnUnmount: false,
//   updateUnregisteredFields: true
})

export default withRedux(withReduxForm(ModificarCpa))
